import PropTypes from 'prop-types';
import { identify, init } from '@fullstory/browser';
import { useEffect } from 'react';

const FullStory = ({ org, isProduction, name, email, canonicalId }) => {
  useEffect(() => {
    init({ orgId: org, devMode: !isProduction });
  }, []);

  useEffect(
    () => {
      if (canonicalId != null) {
        identify(canonicalId, { displayName: name, email: email });
      }
    },
    [canonicalId, name, email]
  );

  return null;
};

FullStory.propTypes = {
  org: PropTypes.string,
  isProduction: PropTypes.bool,
  name: PropTypes.string,
  email: PropTypes.string,
  canonicalId: PropTypes.string
};

export default FullStory;
